import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMoveToBottomStyle0 = gravityIconIndividualCss;

const GravityIconMoveToBottom = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'd4d59117dbf2bdd036f747d8bbbf01bf95694c64', color: this.color, size: this.size }, h("svg", { key: '9a88260abfd2ba4bab8967b7a56484d90fe319fa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '7d188f418e828e084519f02ada0dcbece9751fd3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.79 13.79 5.51 8.51A.3.3 0 0 1 5.72 8h10.56a.3.3 0 0 1 .21.51l-5.28 5.28a.29.29 0 0 1-.42 0Z", fill: "currentColor" }), h("path", { key: '851e355d63ce706f16c77ed13ef411a6bdb706e0', d: "M4.501 19a.5.5 0 0 1-.5-.5v-.495a.5.5 0 0 1 .5-.5l13-.005a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-13Z", fill: "currentColor" }))));
    }
};
GravityIconMoveToBottom.style = GravityIconMoveToBottomStyle0;

export { GravityIconMoveToBottom as gravity_icon_move_to_bottom };

//# sourceMappingURL=gravity-icon-move-to-bottom.entry.js.map